<template>
  <div>
    <v-row
      class="primary report-list-header"
      elevation="4">
      <code class="ma-2 white report-list-header-title pt-1">
        <h2>Report Automation Promotions</h2>
      </code>
      <v-spacer />
    </v-row>
    <v-row justify="space-around">
      <v-sheet
        width="100%"
        elevation="4"
        class="pb-10 px-6">
        <v-row justify="center">
          <v-col cols="12">
            test
          </v-col>
        </v-row>
      </v-sheet>
    </v-row>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.report-list-header {
  height: 50px;
}

.report-list-header-title {
  border-radius: 10px;
  color: black !important;
}
</style>
